define('shared/initializer/form/newHouseAdapters/Lead',[
    '$',
    '../constants',
    '../adapters/Bootstrap3',
    '../adapters/mixins/fields/AgeYoungerThanThirteen',
    '../adapters/mixins/fields/Location',
    '../adapters/mixins/fields/City',
    '../adapters/mixins/fields/Country',
    '../adapters/mixins/fields/Telephone',
    '../adapters/mixins/fields/Email',
    '../adapters/mixins/fields/DynamicSubscribe',
    '../adapters/mixins/ConversionTrackable',
    '../adapters/mixins/ThrobberOnBeforeSubmit',
    '../adapters/mixins/LabelFloatable',
    '../adapters/mixins/EtagTrackable',
    '../adapters/mixins/SubmissionLockable',
    '../adapters/mixins/InputValuePersistable',
    '../adapters/mixins/InputValueRecoverable',
    '../adapters/mixins/AfterSubmitActionTriggerable',
    '../adapters/mixins/LeadAfterSubmit',
    '../adapters/mixins/Redirectable',
    '../adapters/mixins/LeadConfigurable',
    '../adapters/mixins/ClientIdTracking',
    './mixins/SubscriptionEventsTrackable',
    './mixins/LeadSubmittable',
    './mixins/SubscriptionsSavable',
    'shared/lib/ctor',
    './util/createAfterSubmitLifeCycle'
],
function (
    $,
    constants,
    Bootstrap3Adapter,

    AgeYoungerThanThirteenField,
    LocationField,
    CityField,
    CountryField,
    TelephoneField,
    EmailField,
    DynamicSubscribeField,

    ConversionTrackable,
    ThrobberOnBeforeSubmit,
    LabelFloatable,
    EtagTrackable,
    SubmissionLockable,
    InputValuePersistable,
    InputValueRecoverable,
    AfterSubmitActionTriggerable,
    LeadAfterSubmit,
    Redirectable,
    LeadConfigurable,
    ClientIdTracking,
    SubscriptionEventsTrackable,
    LeadSubmittable,
    SubscriptionsSavable,
    ctor,
    createAfterSubmitLifeCycle
) {
    'use strict';

    var METHOD_BEFORE_REDIRECT = 'doBeforeRedirect';

    var Ctor = ctor(function() {
        var me = this;
        me.configs = {
            redirectable: {
                backgroundRedirectWhenSkipped: true,
                url: '/etc/designs/b2c/others/form-default-thankyou'
            }
        };
        me.base.apply(me, arguments);
        me.lifeCycles.push(METHOD_BEFORE_REDIRECT);
        me.mixin(
            // fields
            AgeYoungerThanThirteenField,
            LocationField,
            CityField,
            CountryField,
            TelephoneField,
            EmailField,
            DynamicSubscribeField,

            LeadSubmittable,
            ThrobberOnBeforeSubmit,
            LabelFloatable,
            SubmissionLockable,
            InputValuePersistable,
            InputValueRecoverable,
            ConversionTrackable,
            LeadAfterSubmit,
            LeadConfigurable,
            SubscriptionsSavable,
            createAfterSubmitLifeCycle(METHOD_BEFORE_REDIRECT, me),
            SubscriptionEventsTrackable,
            AfterSubmitActionTriggerable, // Redirectable must follows immediately
            Redirectable
        );

    }).inherit(Bootstrap3Adapter);

    return Ctor;
});

